export default __webpack_public_path__ + "static/media/icon.1c54fb39.png";